<div class="color-picker-menu">
  <div (click)="selectColor(color)" class="color-picker-item" *ngFor="let color of colorList">
    <button class="color-picker-btn" mat-icon-button [style.background]="color">
      <mat-icon class="text-white" *ngIf="selectedColor === color">check_small</mat-icon>
    </button>
  </div>
</div>
